import { Locale } from "@/i18n-config";
import { defineLocaleRecord } from "@/i18n-config";

export type SessionExitCopy = {
  stay: string;
  logoutTitle: string;
  logoutDescription: string;
  logoutConfirm: string;
  leaveTitle: string;
  leaveDescription: string;
  leaveConfirm: string;
};

const sessionExitCopyByLocale = defineLocaleRecord<SessionExitCopy>({
  en: {
    stay: "Stay",
    logoutTitle: "Log out?",
    logoutDescription: "You'll need to sign in again to continue learning.",
    logoutConfirm: "Log out",
    leaveTitle: "Leave course?",
    leaveDescription: "Your marked steps are saved after lesson completion.",
    leaveConfirm: "Leave course",
  },
  fr: {
    stay: "Rester",
    logoutTitle: "Se deconnecter ?",
    logoutDescription: "Vous devrez vous reconnecter pour continuer a apprendre.",
    logoutConfirm: "Se deconnecter",
    leaveTitle: "Quitter le cours ?",
    leaveDescription: "Vos etapes cochees sont enregistrees apres la fin de la lecon.",
    leaveConfirm: "Quitter le cours",
  },
  ru: {
    stay: "Остаться",
    logoutTitle: "Выйти?",
    logoutDescription: "Чтобы продолжить обучение, нужно будет снова войти.",
    logoutConfirm: "Выйти",
    leaveTitle: "Покинуть курс?",
    leaveDescription: "Отмеченные шаги сохраняются после завершения урока.",
    leaveConfirm: "Покинуть курс",
  },
  uk: {
    stay: "Залишитись",
    logoutTitle: "Вийти?",
    logoutDescription: "Щоб продовжити навчання, потрібно буде увійти знову.",
    logoutConfirm: "Вийти",
    leaveTitle: "Покинути курс?",
    leaveDescription: "Позначені кроки зберігаються після завершення уроку.",
    leaveConfirm: "Покинути курс",
  },
  de: {
    stay: "Bleiben",
    logoutTitle: "Abmelden?",
    logoutDescription: "Zum Weiterlernen musst du dich erneut anmelden.",
    logoutConfirm: "Abmelden",
    leaveTitle: "Kurs verlassen?",
    leaveDescription: "Markierte Schritte werden nach dem Abschluss der Lektion gespeichert.",
    leaveConfirm: "Kurs verlassen",
  },
  es: {
    stay: "Quedarme",
    logoutTitle: "Cerrar sesion?",
    logoutDescription: "Tendras que iniciar sesion de nuevo para continuar aprendiendo.",
    logoutConfirm: "Cerrar sesion",
    leaveTitle: "Salir del curso?",
    leaveDescription: "Los pasos marcados se guardan al completar la leccion.",
    leaveConfirm: "Salir del curso",
  },
  it: {
    stay: "Resta",
    logoutTitle: "Uscire?",
    logoutDescription: "Per continuare a imparare dovrai accedere di nuovo.",
    logoutConfirm: "Esci",
    leaveTitle: "Lasciare il corso?",
    leaveDescription: "I passaggi segnati vengono salvati al completamento della lezione.",
    leaveConfirm: "Lascia il corso",
  },
  pt: {
    stay: "Ficar",
    logoutTitle: "Sair?",
    logoutDescription: "Voce precisara entrar novamente para continuar aprendendo.",
    logoutConfirm: "Sair",
    leaveTitle: "Sair da sessao?",
    leaveDescription: "Seus passos marcados sao salvos apos a conclusao da licao.",
    leaveConfirm: "Sair",
  },
});

export function getSessionExitCopy(lang: Locale): SessionExitCopy {
  return sessionExitCopyByLocale[lang];
}
